import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntryByTitle} from '../api/contentstack/sdk/entry'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {BRAND_KEY, BRAND_KEY_FILTER_CS} from '../../brand'

let prefix = ''
if (BRAND_KEY === 'kenwood' || BRAND_KEY === 'braun') prefix = `${BRAND_KEY}_`
/**
 * Hook to fetch all footer entries from contentstack
 */
export const useGetSovraHeader = () => {
    const {stack} = useContentstack()
    const {locale} = useMultiSite()

    const getPreHeaderRes = async () => {
        const response = await getEntryByTitle({
            stack,
            contentTypeUid: `${prefix}pre_header`,
            title: 'preheader',
            locale: locale.alias,
            brand: BRAND_KEY_FILTER_CS,
        })
        return response?.[0] ?? null
    }

    return useQuery(['contentstackGetPreHeader', 'preHeader'], () => getPreHeaderRes())
}
